import { com } from '@eidu/form'
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import entityTypeKindFromString = com.eidu.sharedlib.entity.type.entityTypeKindFromString

// Keep in sync with EntityTypeKind.wellKnown (defined in Kotlin backend)
type WellKnownKindKey = 'User' | 'School' | 'Generic' | 'LearningUnit' | 'Form' | 'Dataset'
export const consoleDefinedKindKeys = ['Chart', 'Dashboard', 'Runtime'] as const
export type ConsoleDefinedKindKey = (typeof consoleDefinedKindKeys)[number]
export type KnownKindKey = WellKnownKindKey | ConsoleDefinedKindKey

export type SidebarGroup = 'entity' | 'document' | 'asset'

type KindDefinition = {
  kind: EntityTypeKind
  label: string
  sidebarSectionId: string
  sidebarGroup: SidebarGroup
}

export const kindDefinitions = {
  User: { kind: EntityTypeKind.User, label: 'Users', sidebarSectionId: 'users', sidebarGroup: 'entity' },
  School: { kind: EntityTypeKind.School, label: 'Schools', sidebarSectionId: 'schools', sidebarGroup: 'entity' },
  Generic: { kind: EntityTypeKind.Generic, label: 'Others', sidebarSectionId: 'others', sidebarGroup: 'entity' },
  LearningUnit: {
    kind: EntityTypeKind.LearningUnit,
    label: 'Learning Units',
    sidebarSectionId: 'learning-units',
    sidebarGroup: 'document',
  },
  Form: {
    kind: EntityTypeKind.Form,
    label: 'Forms',
    sidebarSectionId: 'forms',
    sidebarGroup: 'document',
  },
  Dataset: {
    kind: EntityTypeKind.Dataset,
    label: 'Datasets',
    sidebarSectionId: 'datasets',
    sidebarGroup: 'asset',
  },
  Chart: {
    kind: entityTypeKindFromString('Chart'),
    label: 'Charts',
    sidebarSectionId: 'charts',
    sidebarGroup: 'asset',
  },
  Dashboard: {
    kind: entityTypeKindFromString('Dashboard'),
    label: 'Dashboards',
    sidebarSectionId: 'dashboards',
    sidebarGroup: 'asset',
  },
  Runtime: {
    kind: entityTypeKindFromString('Runtime'),
    label: 'Runtimes',
    sidebarSectionId: 'runtimes',
    sidebarGroup: 'asset',
  },
} satisfies Record<KnownKindKey, KindDefinition>

const kindToKeyMap = new Map(
  (Object.entries(kindDefinitions) as [KnownKindKey, KindDefinition][]).map(([key, def]) => [def.kind.toString(), key])
)

export const getKnownKindKey = (kind: EntityTypeKind): KnownKindKey | undefined => kindToKeyMap.get(kind.toString())

export const knownKinds: readonly EntityTypeKind[] = Object.values(kindDefinitions).map((d) => d.kind)
